import React from 'react';
import { Container, Typography, Box, Grid, Card, CardContent } from '@mui/material';

const services = [
  {
    title: 'Consultoría por Horas',
    description: [
      'Asesoramiento experto para herramientas ERP como HubSpot.',
      'Optimización de pipelines de ventas.',
      'Personalización de objetos/deals.',
      'Integraciones con aplicaciones de terceros.',
    ],
    pricing: 'Tarifa por hora: $35 USD.',
    advantages: [
      'Flexibilidad para contratar solo el tiempo necesario.',
      'Acceso a expertos en diversas herramientas.',
    ],
  },
  {
    title: 'Proyecto Llave en Mano',
    description: [
      'Reuniones de levantamiento de requerimientos.',
      'Planificación detallada y definición de entregas.',
      'Diseños del sistema y módulos.',
      'Pruebas exhaustivas y capacitación al personal.',
      'Soporte post-implementación (1 mes).'
    ],
    pricing: 'Cotización inicial deducible si se aprueba el proyecto.',
    advantages: [
      'Claridad en el alcance y entregables.',
      'Compromiso con plazos y resultados.',
      'Soporte y capacitación incluidos.',
    ],
  },
  {
    title: 'Servicio Profesional Mensual',
    description: [
      'Equipo dedicado durante 6 meses.',
      'Desarrollo personalizado y QA.',
      'Gestión de infraestructura y despliegue.',
      'Capacitación continua al personal.',
    ],
    pricing: 'Tarifa mensual: $2,000 USD (mínimo 6 meses).',
    advantages: [
      'Equipo multidisciplinario continuo.',
      'Flexibilidad en prioridades.',
      'Costos predecibles y distribuidos.',
    ],
  },
];

const Logo = () => (
  <Box sx={{ textAlign: 'center', my: 4 }}>
    <Typography variant="h3" fontWeight="bold" color="primary">
      Annona-i
    </Typography>
    <Typography variant="subtitle1" color="textSecondary">
      Soluciones tecnológicas a la medida de tu negocio
    </Typography>
  </Box>
);

const ServiceCard = ({ title, description, pricing, advantages }) => (
  <Card
    variant="outlined"
    sx={{
      borderRadius: 4,
      boxShadow: 6,  // Aumentamos la sombra para darle más profundidad
      transition: 'transform 0.3s ease, box-shadow 0.3s ease',  // Animación al pasar el mouse
      '&:hover': {
        transform: 'translateY(-10px)',  // Efecto de hover
        boxShadow: 12,  // Sombra más fuerte al pasar el mouse
      },
    }}
  >
    <CardContent>
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        {title}
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        {pricing}
      </Typography>
      <Typography variant="body1" gutterBottom>
        Incluye:
      </Typography>
      <ul>
        {description.map((item, index) => (
          <li key={index}><Typography variant="body2">{item}</Typography></li>
        ))}
      </ul>
      <Typography variant="body1" gutterBottom>
        Ventajas:
      </Typography>
      <ul>
        {advantages.map((item, index) => (
          <li key={index}><Typography variant="body2">{item}</Typography></li>
        ))}
      </ul>
    </CardContent>
  </Card>
);

export default function ServicesPage() {
  return (
    <Container sx={{ py: 6 }}>
      <Logo />
      <Typography variant="h4" gutterBottom align="center">
        Nuestros Servicios
      </Typography>
      <Typography variant="body1" paragraph align="center">
        En Annona-i, entendemos la importancia de contar con soluciones tecnológicas que se alineen perfectamente con las necesidades y objetivos de su empresa. Por ello, nos complace presentarle tres modelos de servicio diseñados para ofrecer flexibilidad, eficiencia y valor agregado en la implementación y personalización de sistemas ERP y soluciones relacionadas.
      </Typography>
      <Grid container spacing={6} justifyContent="center">
        {services.map((service, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <ServiceCard {...service} />
          </Grid>
        ))}
      </Grid>
      <Box className="mt-8">


  <Box mt={2}>
    <Typography variant="body1">¿Tienes alguna duda o deseas más información? <a href="https://form.jotform.com/250967484997885" target="_blank" rel="noopener noreferrer">Contáctanos aquí</a></Typography>
  </Box>
</Box>

    </Container>
  );
}